/**
 * 거래마다 쓰던 AI 회고를 멈췄다는 안내 (2026-10-18 · 사용자 결정 "오늘 배포로 끄자" · 미확인 Q65 · 3회차 결산)
 *
 * 서버 설정 trading.yml paper.review-batch-size = 0 과 짝이다. 0 이면 저점매수 · 스윙 · 추천 · 미국 회고가 더 쓰이지 않고,
 * 회차 종합 분석만 회차가 끝나는 날 그대로 쓰인다.
 * 🔴 회고를 되살리면(값을 다시 올리면) 이 문구도 같은 커밋에서 되돌린다(CLAUDE.md 6절 9항).
 * 왜 멈췄나 — 3회차 회고 184편을 대조했더니 숫자 기록 이상의 새 정보가 없었고, 바꿀 만한 제안도 없었다(규칙이 막는다).
 */
export const REVIEW_PAUSED_SINCE = '2026년 10월 18일';

/** 회고 목록 아래 · 빈 자리에 붙는 한 줄 */
export const REVIEW_PAUSED_NOTE =
  `거래마다 쓰던 AI 회고는 ${REVIEW_PAUSED_SINCE}부터 멈췄습니다(3회차 결산 — 숫자 기록 이상의 새 정보가 없었습니다). 회차 종합 분석은 회차가 끝나는 날 그대로 씁니다.`;
